import React from 'react';
import LandingHeroText from '../ui/landing-hero-text';
import LandingPrimaryText from '../ui/landing-primary-text';
import LandingPrimaryButton from '../ui/landing-primary-button';
import { prefix } from '../../lib/auth';
import {useRouter} from 'next/router';
import { useTranslations } from 'next-intl';

const LandingPreFooter = () => {
    const router = useRouter();
    const t = useTranslations('landing');
    
    return (
        <div className='bg-[url("/images/pre-footer-bg.png")] bg-cover bg-no-repeat bg-center gap-[53px] bg-grey-900 max-w-[90%] lg:max-w-[1240px] m-auto mb-[65px] h-[514px] grid items-center content-center rounded-[55px]'>
            <div className='grid gap-[22px]'>
                <LandingHeroText additionalclasses='!text-[22px] lg:!text-[40px] '>{t('preFooterTitle')}</LandingHeroText>
                <LandingPrimaryText additionalclasses='!text-[18px] !text-white-50 !max-w-[300px] lg:!max-w-full m-auto'>{t('preFooterSubtitle')}</LandingPrimaryText>
            </div>
            <LandingPrimaryButton onClick={() => router.push(`http://${prefix()}accounts.workpeg.com/register?peg=email`)}>{t('getStarted')}</LandingPrimaryButton>
        </div>
    );
};

export default LandingPreFooter;